module.exports = __webpack_public_path__ + "img/Glow.48148625.png";